var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Organisation Management")]),_c('v-divider',{staticClass:"mx-4",attrs:{"inset":"","vertical":""}}),_c('OrgCreate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }